import { PRODUCT_FLOW } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(PRODUCT_FLOW);
const actions = {
  ...rawActions,
  ...thunkFactory(PRODUCT_FLOW, '/fluxprod/'),
};
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(PRODUCT_FLOW, initialState);

// SAGAS
const sagas = sagasFactory(PRODUCT_FLOW, '/fluxprod/');
export { sagas };
